import { __decorate } from "tslib";
/* eslint-disable lines-between-class-members */
// eslint-disable-next-line max-classes-per-file
import { css, html } from 'lit';
import { customElement, property, state, query } from 'lit/decorators.js';
import { until } from 'lit/directives/until.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '@material/mwc-button';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import { parseJwt, initializeWcConfig } from '../../common/helpers.js';
import '@vaadin/tabs';
import '@vaadin/vertical-layout';
import '@vaadin/tabs/theme/material/vaadin-tabs';
import { AdviseeSummaryRequest } from '../../models/adviseeSummaryRequest.js';
import { FulfillmentRequest } from '../../models/fulfillmentRequest.js';
import { UserLevelBenefitRequest } from '../../models/userLevelBenefitRequest.js';
import { CustomActionConstant } from '../../common/customActionConstants.js';
import './history.js';
import './profile.js';
import './actionSteps.js';
import './articles.js';
import './phrases.js';
import './resources.js';
import '../../common/loadingSpinner.js';
let FulfillmentSummaryElement = class FulfillmentSummaryElement extends RxElement {
    constructor() {
        super(...arguments);
        this.adviseeSummary = new AdviseeSummaryRequest();
        this.buttonDisabled = false;
        this.sendFulfillmentMessage = '';
        this.coachEmail = '';
        this.caseId = '';
        this.fulfillment = new FulfillmentRequest();
        this.customActionItem = 'customActionItem';
        this.parsedToken = {};
        this.content = html ``;
        this.pages = ['History', 'Profile', 'Phrases'];
        this.userLevelBenefit = new UserLevelBenefitRequest;
        this.errorIsCopied = false;
        this.copyErrorToClipboard = async (fulfillmentStatus) => {
            var _a;
            await navigator.clipboard.writeText((_a = `${fulfillmentStatus}: ${this.fulfillment.errorMessage}`) !== null && _a !== void 0 ? _a : '');
            this.errorIsCopied = true;
        };
        this.renderCopyButton = (fulfillmentStatus) => html `<div><button class="copyError" @click="${() => this.copyErrorToClipboard(fulfillmentStatus)}">${!this.errorIsCopied ? 'Copy Error Message' : 'Error Message Copied'}</button></div>`;
        this.renderTabs = () => html `<div class="fulfillmentInfo">
                    <vaadin-tabs
                      class="fulfillmentInfo__nav"
                      selected="0"
                      @selected-changed="${this.selectedChanged}"
                    >
                      ${this.pages.map(s => html `<vaadin-tab class="fulfillmentInfo__navItem"
                            >${s}</vaadin-tab
                          >`)}
                    </vaadin-tabs>
                    <vaadin-vertical-layout class="fulfillmentInfo__content">
                      ${this.content}
                    </vaadin-vertical-layout>
                  </div>`;
        this.renderUserError = () => html `
      <div class="errorContainer">
        <h1>No Hub User Exists</h1>
        <p>
          This can happen when a Salesforce Contact has been created but the user has never logged in to their Hub.
          A user will be created for them upon completion of a fulfillment.  If you feel this is in error, please 
          update the Salesforce Contact's email address and employeeid if available.
        </p>
      </div>
      <button class="refresh" @click="${() => { window.location.href = window.location.href; }}">Refresh this page</button>
    `;
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        this.parsedToken = parseJwt(this.blueUser.accessToken ? this.blueUser.accessToken : '');
        this.coachEmail = this.parsedToken.upn;
        const pathArray = window.location.pathname.split('/').filter(Boolean);
        this.caseId = pathArray[pathArray.length - 1];
        this.fetchFulfillment().then(data => {
            var _a, _b, _c;
            if (this.fulfillment.status === 'FOUND') {
                this.hubSlug = (_a = data.fulfillment) === null || _a === void 0 ? void 0 : _a.hubSlug;
                this.email = (_b = data.fulfillment) === null || _b === void 0 ? void 0 : _b.salesforceContact.email;
                const denyCustomActionsCheck = CustomActionConstant.CUSTOM_ACTION_DENY.includes((_c = this.hubSlug) !== null && _c !== void 0 ? _c : '');
                if (denyCustomActionsCheck) {
                    this.customActionItem = '';
                }
                initializeWcConfig(data)
                    .then(config => {
                    globalThis.wcConfig = config;
                })
                    .then(result => {
                    var _a, _b;
                    this.tinymceEditor = html `<tinymce-editor
                plugins="blue-assist link lists autolink searchreplace"
                noneditable_class="mceNonEditable"
                toolbar="undo redo randomIntro randomOutro | bold italic | cut copy paste link | numlist bullist | searchreplace | ${this.customActionItem}"
                contextmenu="disabled"
                config="wcConfig"
              ></tinymce-editor>`;
                    this.backgroundSave();
                    if ((_a = data.fulfillment) === null || _a === void 0 ? void 0 : _a.hasActions) {
                        this.pages.splice(this.pages.length - 1, 0, 'Action Steps');
                    }
                    if ((_b = data.fulfillment) === null || _b === void 0 ? void 0 : _b.hasArticles) {
                        this.pages.splice(this.pages.length - 1, 0, 'Articles');
                    }
                    if (this.adviseeSummary.status === 'INITIALIZING' &&
                        this.blueUser.accessToken) {
                        this.fetchAdvisee();
                    }
                });
            }
            else if (this.adviseeSummary.status === 'INITIALIZING' &&
                this.blueUser.accessToken) {
                this.fetchAdvisee();
            }
        });
    }
    disconnectedCallback() {
        var _a;
        // eslint-disable-next-line wc/guard-super-call
        super.disconnectedCallback();
        clearInterval(this.saveTimer);
        if (((_a = this.fulfillment.fulfillment) === null || _a === void 0 ? void 0 : _a.status) === 'open') {
            this.saveFulfillment();
        }
    }
    selectedChanged(e) {
        if (this.fulfillment.fulfillment) {
            const { fulfillment } = this.fulfillment;
            if (this.pages[e.detail.value] === 'History') {
                this.content = html `<fulfillment-history
          .fulfillment="${fulfillment}"
          .case="${fulfillment.salesforceCase.caseNumber}"
          .coachName="${fulfillment.coachName}"
          .adviseeName="${`${fulfillment.salesforceContact.firstName} ${fulfillment.salesforceContact.lastName}`}"
        ></fulfillment-history>`;
            }
            if (this.pages[e.detail.value] === 'Action Steps') {
                this.content = html `<fulfillment-action-steps></fulfillment-action-steps>`;
            }
            if (this.pages[e.detail.value] === 'Articles') {
                this.content = html `<fulfillment-articles
          .account="${fulfillment.hubSlug}"
        ></fulfillment-articles>`;
            }
            if (this.pages[e.detail.value] === 'Phrases') {
                this.content = html `<fulfillment-phrases
          .account="${fulfillment.hubSlug}"
        ></fulfillment-phrases>`;
            }
        }
        if (this.pages[e.detail.value] === 'Profile') {
            this.content = html `<fulfillment-profile
        .adviseeSummary="${this.adviseeSummary}"
        .userId="${this.userId}"
        .hubId="${this.hubId}"
        .fulfillmentId="${this.fulfillment.fulfillment ? this.fulfillment.fulfillment.id : null}"
      ></fulfillment-profile>`;
        }
    }
    async fetchAdvisee() {
        var _a;
        const fulfillmentId = (_a = this.fulfillment.fulfillment) === null || _a === void 0 ? void 0 : _a.id;
        if (!fulfillmentId && !this.userId) {
            this.adviseeSummary = {
                status: 'ERRORED',
                errorMessage: 'No fulfillment ID was provided.',
            };
            return;
        }
        let requestUrl = `${process.env.API_URL}/blue/fulfillments/${fulfillmentId}/userSummary`;
        if (!fulfillmentId && this.userId) {
            requestUrl = `${process.env.API_URL}/blue/hub/${this.hubId}/user/${this.userId}/userSummary`;
        }
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const results = await fetch(new Request(requestUrl, {
                headers,
            }));
            const adviseeErrorMessage = `Error ${results.status}: ${results.statusText} was returned when requesting the resource at ${requestUrl}.`;
            if (results.ok || results.status === 200) {
                this.adviseeSummary = {
                    status: 'FOUND',
                    adviseeSummary: JSON.parse(await results.text(), (key, value) => {
                        switch (key) {
                            case 'createdDate':
                            case 'completedDate':
                                if (value) {
                                    return new Date(value);
                                }
                                return value;
                            default:
                                return value;
                        }
                    }),
                };
            }
            else if (results.status === 404) {
                this.adviseeSummary = {
                    status: 'NOT_FOUND',
                    errorMessage: adviseeErrorMessage,
                };
            }
            else {
                this.adviseeSummary = {
                    status: 'ERRORED',
                    errorMessage: adviseeErrorMessage,
                };
            }
        }
        catch (error) {
            this.adviseeSummary = {
                status: 'ERRORED',
                errorMessage: `The following error occured when requesting ${requestUrl}: ${error.name ? error.name : ''} ${error.message ? error.message : ''}`,
            };
        }
    }
    async fetchFulfillment() {
        const requestUrl = `${process.env.API_URL}/blue/fulfillments/case/${this.caseId}`;
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const results = await fetch(new Request(requestUrl, {
                headers,
            }));
            const json = await results.json();
            let fulfillmentErrorMessage = `Error ${results.status}: ${results.statusText} was returned when trying to load ${requestUrl}.`;
            if (json.someBadGatewayInfo) {
                fulfillmentErrorMessage += `<div>${json.someBadGatewayInfo.replace(/\n/, '<br>')}</div>`;
            }
            if (results.ok || results.status === 200) {
                this.fulfillment = {
                    status: 'FOUND',
                    fulfillment: json,
                };
                this.userId = json.userId;
                this.hubId = json.hubId;
                this.fetchUserLevelBenefit();
                return this.fulfillment;
            }
            if (results.status === 404) {
                this.fulfillment = {
                    status: 'NOT_FOUND',
                    errorMessage: fulfillmentErrorMessage,
                };
                if (json.hubId) {
                    this.hubId = json.hubId;
                }
                if (json.userId) {
                    this.userId = json.userId;
                    this.pages = ['Profile'];
                }
                if (json.employeeId) {
                    this.employeeId = json.employeeId;
                    this.email = json.email;
                }
                if (json.hubId && (this.userId || this.employeeId)) {
                    this.fetchUserLevelBenefit();
                }
                return this.fulfillment;
            }
            this.fulfillment = {
                status: 'ERRORED',
                errorMessage: fulfillmentErrorMessage,
            };
            return this.fulfillment;
        }
        catch (error) {
            this.fulfillment = {
                status: 'ERRORED',
                errorMessage: `The following error occured when requesting ${requestUrl}: ${error}`,
            };
            return this.fulfillment;
        }
    }
    async fetchUserLevelBenefit() {
        let requestUrl = '';
        if (this.hubId && this.userId) {
            requestUrl = `${process.env.API_URL}/blue/hub/${this.hubId}/userBenefits?userId=${this.userId}`;
        }
        if (this.hubId && !this.userId) {
            requestUrl = `${process.env.API_URL}/blue/hub/${this.hubId}/userBenefits`;
        }
        if (this.hubId && this.employeeId) {
            requestUrl = `${process.env.API_URL}/blue/hub/${this.hubId}/userBenefits?employeeId=${this.employeeId}`;
        }
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            const results = await fetch(new Request(requestUrl, {
                headers,
            }));
            const json = await results.json();
            const userLevelBenefitErrorMessage = `Error ${results.status}: ${results.statusText} was returned when trying to load ${requestUrl}.`;
            if (results.ok || results.status === 200) {
                this.userLevelBenefit = {
                    status: 'FOUND',
                    userLevelBenefit: json,
                };
                return this.userLevelBenefit;
            }
            if (results.status === 404) {
                this.userLevelBenefit = {
                    status: 'NOT_FOUND',
                    errorMessage: userLevelBenefitErrorMessage,
                };
                return this.userLevelBenefit;
            }
            this.userLevelBenefit = {
                status: 'ERRORED',
                errorMessage: userLevelBenefitErrorMessage,
            };
            return this.userLevelBenefit;
        }
        catch (error) {
            this.userLevelBenefit = {
                status: 'ERRORED',
                errorMessage: `The following error occured when requesting ${requestUrl}: ${error}`,
            };
            return this.userLevelBenefit;
        }
    }
    async _buildFulfillment() {
        const { fulfillment } = this.fulfillment;
        const emailBody = globalThis.tinyMCEContent.replace(/<!--(.*?)-->/g, '');
        const emailSubject = this._subject.value;
        const emailRecipient = this._recipientEmail.options[this._recipientEmail.selectedIndex].text;
        const ccRecipient = this._ccEmail.value;
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(emailBody, 'text/html');
        const domArticles = htmlDoc.querySelectorAll(`[data-type="article"]`);
        const domPhrases = htmlDoc.querySelectorAll(`[data-type="phrase"]`);
        const domActionSteps = htmlDoc.querySelectorAll(`[data-type="action"]`);
        const domEvents = htmlDoc.querySelectorAll(`[data-type="event"]`);
        const domCustomActions = htmlDoc.querySelectorAll(`[data-type="customAction"]`);
        const articleArray = [];
        const actionArray = [];
        const phraseArray = [];
        const eventArray = [];
        const customActionArray = [];
        const articles = await new Promise((resolve, reject) => {
            for (let i = 0; i < domArticles.length; i++) {
                const elem = domArticles[i];
                const id = elem.getAttribute('data-id');
                const slug = elem.getAttribute('data-slug');
                const title = elem.getAttribute('data-title');
                if (id && slug && title) {
                    const isFound = articleArray.some(el => {
                        if (el.contentId === id) {
                            return true;
                        }
                        return false;
                    });
                    if (!isFound) {
                        const a = {
                            contentId: id,
                            slug,
                            title,
                        };
                        articleArray.push(a);
                    }
                }
            }
            resolve('done');
        });
        const actionSteps = await new Promise((resolve, reject) => {
            for (let i = 0; i < domActionSteps.length; i++) {
                const elem = domActionSteps[i];
                const id = elem.getAttribute('data-id');
                const milestoneLevel = elem.getAttribute('data-rank');
                const slug = elem.getAttribute('data-slug');
                const title = elem.getAttribute('data-title');
                if (id && milestoneLevel && slug && title) {
                    const isFound = actionArray.some(el => {
                        if (id) {
                            if (el.actionId === parseInt(id, 10)) {
                                return true;
                            }
                        }
                        return false;
                    });
                    if (!isFound) {
                        const a = {
                            actionId: parseInt(id, 10),
                            slug,
                            milestoneLevel: parseInt(milestoneLevel, 10),
                            title,
                        };
                        actionArray.push(a);
                    }
                }
            }
            resolve('done');
        });
        const phrases = await new Promise((resolve, reject) => {
            for (let i = 0; i < domPhrases.length; i++) {
                const elem = domPhrases[i];
                const id = elem.getAttribute('data-id');
                const typeId = elem.getAttribute('data-typeid');
                const type = elem.getAttribute('data-phrasetype');
                const title = elem.getAttribute('data-title');
                const phrase = elem.getAttribute('data-phrase');
                if (id && typeId && type && title && phrase) {
                    const isFound = phraseArray.some(el => {
                        if (el.phrase === phrase) {
                            return true;
                        }
                        return false;
                    });
                    if (!isFound) {
                        const p = {
                            id,
                            typeId,
                            type,
                            title,
                            phrase,
                        };
                        phraseArray.push(p);
                    }
                }
            }
            resolve('done');
        });
        const sessions = await new Promise((resolve, reject) => {
            for (let i = 0; i < domEvents.length; i++) {
                const elem = domEvents[i];
                const sessionId = elem.getAttribute('data-id');
                const title = elem.getAttribute('data-title');
                const eventDate = elem.getAttribute('data-date');
                const slug = elem.getAttribute('data-slug');
                if (sessionId && title && eventDate && slug) {
                    const isFound = eventArray.some(el => {
                        if (el.sessionId === sessionId) {
                            return true;
                        }
                        return false;
                    });
                    if (!isFound) {
                        const p = {
                            sessionId,
                            title,
                            eventDate,
                            slug,
                        };
                        eventArray.push(p);
                    }
                }
            }
            resolve('done');
        });
        const customActions = await new Promise((resolve, reject) => {
            for (let i = 0; i < domCustomActions.length; i++) {
                const elem = domCustomActions[i];
                const id = elem.getAttribute('data-id');
                const title = elem.getAttribute('data-title');
                const description = elem.getAttribute('data-description');
                const getStartedLink = elem.getAttribute('data-getstartedlink');
                if (id && title) {
                    const isFound = customActionArray.some(el => {
                        if (title) {
                            if (el.title === title) {
                                return true;
                            }
                        }
                        return false;
                    });
                    if (!isFound) {
                        const a = {
                            id,
                            title,
                            description: description || "",
                            getStartedLink: getStartedLink || "",
                        };
                        customActionArray.push(a);
                    }
                }
            }
            resolve('done');
        });
        if (typeof fulfillment !== 'undefined') {
            return Promise.all([articles, actionSteps, phrases, sessions, customActions]).then(values => {
                if (emailRecipient && emailBody && emailSubject) {
                    const email = {
                        from: '',
                        to: emailRecipient,
                        subject: emailSubject,
                        body: emailBody,
                        cc: ccRecipient,
                    };
                    email.from = this.coachEmail;
                    email.to = emailRecipient;
                    email.subject = emailSubject;
                    email.body = emailBody;
                    fulfillment.email = [email];
                }
                fulfillment.articles = articleArray;
                fulfillment.actions = actionArray;
                fulfillment.phrases = phraseArray;
                fulfillment.sessions = eventArray;
                fulfillment.customActions = customActionArray;
                return fulfillment;
            });
        }
    }
    async _saveFulfillment(fulfillment) {
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            headers.append('Content-Type', `application/json`);
            const results = await fetch(new Request(`${process.env.API_URL}/blue/updatefulfillments`, {
                headers,
                method: 'POST',
                body: JSON.stringify(fulfillment),
            }));
            return results;
        }
        catch (error) {
            return error;
        }
    }
    async _sendFulfillment(fulfillment) {
        this.sendFulfillmentMessage = '';
        this.buttonDisabled = true;
        const requestUrl = `${process.env.API_URL}/blue/sendemail`;
        try {
            const headers = new Headers();
            headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
            headers.append('Content-Type', `application/json`);
            const results = await fetch(new Request(requestUrl, {
                headers,
                method: 'POST',
                body: JSON.stringify(fulfillment),
            }));
            const fulfillmentSendErrorMessage = `Error ${results.status}: ${results.statusText} was returned when trying to send the fulfillment ${requestUrl}.`;
            if (results.ok || results.status === 200) {
                this.sendFulfillmentMessage =
                    'Fulfillment successfully sent. Redirecting...';
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            }
            else {
                this.sendFulfillmentMessage = fulfillmentSendErrorMessage;
                return results;
            }
        }
        catch (error) {
            this.sendFulfillmentMessage = `The following error occured when trying to send the fulfillment from ${requestUrl}: ${error.name ? error.name : ''} ${error.message ? error.message : ''}`;
            return error;
        }
    }
    async saveFulfillment() {
        if (this.buttonDisabled) {
            return;
        }
        this._buildFulfillment().then(fulfillment => {
            if (fulfillment) {
                const results = this._saveFulfillment(fulfillment);
            }
        });
    }
    async sendFulfillment(e) {
        e.preventDefault();
        this._buildFulfillment().then(fulfillment => {
            if (fulfillment) {
                const results = this._sendFulfillment(fulfillment);
            }
        });
    }
    saveInterval() {
        return setInterval(() => {
            this.saveFulfillment();
        }, 2 * 30 * 1000);
    }
    cancelDialog(e) {
        e.preventDefault();
        this._dialog.showModal();
    }
    cancelClose(e) {
        e.preventDefault();
        this._dialog.close();
    }
    async cancelFulfillment(e) {
        var _a, _b;
        e.preventDefault();
        const reason = this._cancelReason.value;
        const requestUrl = `${process.env.API_URL}/blue/fulfillment/${(_b = (_a = this.fulfillment) === null || _a === void 0 ? void 0 : _a.fulfillment) === null || _b === void 0 ? void 0 : _b.id}/cancel`;
        if (reason && (reason.trim() !== '' || reason !== null)) {
            try {
                const headers = new Headers();
                headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
                headers.append('Content-Type', `application/json`);
                const body = { Justification: this._cancelReason.value };
                const results = await fetch(new Request(requestUrl, {
                    headers,
                    method: 'POST',
                    body: JSON.stringify(body),
                }));
                const fulfillmentCancelErrorMessage = `Error ${results.status}: ${results.statusText} was returned when trying to cancel the fulfillment ${requestUrl}.`;
                if (results.ok || results.status === 200) {
                    this.cancelStatus =
                        'Fulfillment cancelled successfully. Redirecting...';
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 2000);
                }
                else {
                    this.cancelStatus = fulfillmentCancelErrorMessage;
                    return null;
                }
            }
            catch (error) {
                this.cancelStatus = `The following error occured when trying to cancel the fulfillment from ${requestUrl}: ${error.name ? error.name : ''} ${error.message ? error.message : ''}`;
                return error;
            }
        }
        else {
            this.cancelStatus = 'Cancellation justification cannot be empty';
        }
        return null;
    }
    backgroundSave() {
        var _a;
        if (((_a = this.fulfillment.fulfillment) === null || _a === void 0 ? void 0 : _a.status) === 'open') {
            this.saveTimer = this.saveInterval();
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15;
        if (this.blueUser.status !== 'AUTHENTICATED') {
            return html ``;
        }
        switch (this.fulfillment.status) {
            case 'FOUND': {
                const { fulfillment } = this.fulfillment;
                if (!fulfillment) {
                    return html `The fullfillment could not be found. Please check that the Salesforce Case has been created.`;
                }
                if (fulfillment.status === 'closed' &&
                    fulfillment.subStatus === 'manuallyCancelled') {
                    return html `
            <a href="/dashboard" class="fulfillmentHeader">
              <svg class="fulfillmentHeaderIcon">
                <use
                  href="/static/icons.svg#chevronLeft"
                  xlink:href="/static/icons.svg#chevronLeft"
                />
              </svg>
              Case #
              ${fulfillment.salesforceCase.caseNumber}
            </a>
            <p class="">
              <strong>Fulfillment:</strong> Manually Cancelled<br>
              <strong>Justification:</strong> ${(_a = fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.cancellation) === null || _a === void 0 ? void 0 : _a.justification}<br>
              <strong>Cancelled On:</strong> ${new Intl.DateTimeFormat('en-US', {
                        dateStyle: 'long',
                    }).format(new Date((_c = (_b = fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.cancellation) === null || _b === void 0 ? void 0 : _b.cancelledOn) !== null && _c !== void 0 ? _c : ''))}<br>
              <strong>Cancelled By:</strong> ${(_d = fulfillment === null || fulfillment === void 0 ? void 0 : fulfillment.cancellation) === null || _d === void 0 ? void 0 : _d.cancelledById}
            </p>`;
                }
                if (fulfillment.status === 'closed' && fulfillment.email.length) {
                    this.latestEmail = fulfillment.email[fulfillment.email.length - 1];
                    fulfillment.email.sort((a, b) => Date.parse(a.createdDateTime || '0') -
                        Date.parse(b.createdDateTime || '0'));
                    this.lastSentEmail = fulfillment.email
                        .slice()
                        .reverse()
                        .find(e => { var _a; return (_a = e.from) === null || _a === void 0 ? void 0 : _a.includes('@financialfinesse.com'); });
                    this.lastReceivedEmail = fulfillment.email
                        .slice()
                        .reverse()
                        .find(e => { var _a; return !((_a = e.from) === null || _a === void 0 ? void 0 : _a.includes('@financialfinesse.com')); });
                }
                return html `${!fulfillment
                    ? html `Fulfillment Not Found.<br><br>${unsafeHTML(this.fulfillment.errorMessage)}`
                    : html `
              <a href="/dashboard" class="fulfillmentHeader">
                <svg class="fulfillmentHeaderIcon">
                  <use
                    href="/static/icons.svg#chevronLeft"
                    xlink:href="/static/icons.svg#chevronLeft"
                  />
                </svg>
                ${fulfillment.salesforceContact.firstName}
                ${fulfillment.salesforceContact.lastName}
              </a>
              <div class="fulfillmentHeaderMeta">
                Case #: ${fulfillment.salesforceCase.caseNumber} 
                ${this.userLevelBenefit.status === 'FOUND'
                        && ((_e = this.userLevelBenefit.userLevelBenefit) === null || _e === void 0 ? void 0 : _e.wikiLink)
                        && ((_f = this.userLevelBenefit.userLevelBenefit) === null || _f === void 0 ? void 0 : _f.benefitGroupFriendly)
                        ? html ` | Benefit Group: <strong>
                      <a href="${(_g = this.userLevelBenefit.userLevelBenefit) === null || _g === void 0 ? void 0 : _g.wikiLink}" target="_blank">${(_h = this.userLevelBenefit.userLevelBenefit) === null || _h === void 0 ? void 0 : _h.benefitGroupFriendly}</a></strong>`
                        : null}
              </div>
              <div class="fulfillment">
                <div class="fulfillmentContainer">
                  <div class="fulfillmentEmail">
                    <div class="fulfillmentEmail__header">
                      <div class="fulfillmentEmail__headerMeta">
                        <div class="fulfillmentEmail__headerName">
                          ${fulfillment.salesforceContact.firstName}
                          ${fulfillment.salesforceContact.lastName}
                        </div>
                        <div class="fulfillmentEmail__headerDate">
                          ${new Intl.DateTimeFormat('en-US', {
                        dateStyle: 'long',
                    }).format(new Date(fulfillment.salesforceCase.createdDate))}
                        </div>
                      </div>
                      <div class="fulfillmentEmail__headerTo">
                        <span class="fulfillmentEmail__headerToLabel">To:</span>
                        ${fulfillment.status === 'open'
                        ? html `<select
                              id="recipientEmail__input"
                              class="fulfillmentEmail__headerToInput"
                            >
                              ${((_j = fulfillment.salesforceContact) === null || _j === void 0 ? void 0 : _j.alt_Email__c)
                            ? html ` <option
                                    value="${(_k = fulfillment.salesforceContact) === null || _k === void 0 ? void 0 : _k.alt_Email__c}"
                                  >
                                    ${(_l = fulfillment.salesforceContact) === null || _l === void 0 ? void 0 : _l.alt_Email__c}
                                  </option>`
                            : ''}
                              ${((_m = fulfillment.salesforceContact) === null || _m === void 0 ? void 0 : _m.email)
                            ? html ` <option
                                    value="${(_o = fulfillment.salesforceContact) === null || _o === void 0 ? void 0 : _o.email}"
                                  >
                                    ${(_p = fulfillment.salesforceContact) === null || _p === void 0 ? void 0 : _p.email}
                                  </option>`
                            : ''}
                            </select>`
                        : html `<p class="fulfillmentEmail__headerToInput">
                              ${(_q = this.latestEmail) === null || _q === void 0 ? void 0 : _q.to}
                            </p>`}
                      </div>
                      <div class="fulfillmentEmail__headerCc">
                        <span class="fulfillmentEmail__headerCcLabel">CC:</span>
                        ${fulfillment.status === 'open'
                        ? html ` ${((_r = fulfillment.email[0]) === null || _r === void 0 ? void 0 : _r.cc)
                            ? html `<input
                                  type="text"
                                  id="ccEmail__input"
                                  class="fulfillmentEmail__headerCcInput"
                                  .value="${(_s = fulfillment.email[0]) === null || _s === void 0 ? void 0 : _s.cc}"
                                >`
                            : html `<input
                                  type="text"
                                  id="ccEmail__input"
                                  class="fulfillmentEmail__headerCcInput"
                                >`}`
                        : html `<p class="fulfillmentEmail__headerCcInput">
                              ${(_t = this.latestEmail) === null || _t === void 0 ? void 0 : _t.cc}
                            </p>`}
                      </div>
                      <div class="fulfillmentEmail__headerSubject">
                        <div class="fulfillmentEmail__headerSubjectLabel">
                          Subject:
                        </div>
                        ${fulfillment.status === 'open'
                        ? html ` ${((_u = fulfillment.email[0]) === null || _u === void 0 ? void 0 : _u.subject)
                            ? html `<input
                                  id="subject__input"
                                  class="fulfillmentEmail__headerSubjectInput"
                                  type="text"
                                  .value="${(_v = fulfillment.email[0]) === null || _v === void 0 ? void 0 : _v.subject}"
                                />`
                            : html `<input
                                  id="subject__input"
                                  class="fulfillmentEmail__headerSubjectInput"
                                  type="text"
                                  value="Following up on our conversation"
                                />`}`
                        : html `<p class="fulfillmentEmail__headerSubjectInput">
                              ${unsafeHTML((_w = this.latestEmail) === null || _w === void 0 ? void 0 : _w.subject)}
                            </p>`}
                      </div>
                    </div>
                    ${fulfillment.status === 'open'
                        ? until(this.tinymceEditor, html `<span>Loading...</span>`)
                        : html `<p class="fulfillmentEmail__headerToInput">
                          ${unsafeHTML((_x = this.latestEmail) === null || _x === void 0 ? void 0 : _x.body)}
                        </p>`}
                  </div>
                  ${fulfillment.status === 'open'
                        ? html `
                      <div id="fulfillmentEmail__bottomButtons">
                        <mwc-button
                            raised
                            id="fullfillmentCancel"
                            label="cancel"
                            style="--mdc-theme-primary:red;"
                            class="fulfillmentEmail__headerButton"
                            @click="${this.cancelDialog}"
                            ?disabled=${this.buttonDisabled}
                          ></mwc-button>
                        <mwc-button
                            raised
                            id="send-button"
                            label="send"
                            style="--mdc-theme-primary:#2C7FAD;"
                            @click="${this.sendFulfillment}"
                            ?disabled=${this.buttonDisabled}
                          ></mwc-button>
                      </div>`
                        : null}
                  ${this.sendFulfillmentMessage
                        ? html `<div class="sendMessage">${this.sendFulfillmentMessage}</div>`
                        : ''}
                  ${this.renderTabs()}
                </div>
                <fulfillment-resources
                  .topic="${fulfillment.salesforceCase.topics_1__c}"
                  .subtopic="${fulfillment.salesforceCase.sub_Topics_1__c}"
                  .oasisToken="${(_y = this.adviseeSummary.adviseeSummary) === null || _y === void 0 ? void 0 : _y.oasisImpersonationToken}"
                  .hubSlug="${(_z = this.adviseeSummary.adviseeSummary) === null || _z === void 0 ? void 0 : _z.slug}"
                  .hasActions="${fulfillment.hasActions}"
                  .hasArticles="${fulfillment.hasArticles}"
                ></fulfillment-resources>
              </div>
              ${fulfillment.status === 'open'
                        ? html `<dialog id="cancel__dialog">
                    <div class="cancel__header">
                      <h1>Cancel Fulfillment</h1>
                    </div>
                    <div class="cancel__content">
                      <textarea id="fulfillmentCancellation__reason" rows="4" cols="50"></textarea>
                    </div>
                    <div id="cancel__status">${this.cancelStatus}</div>
                    <div class="cancel__bottomControls">
                      <mwc-button
                        label="cancel fulfillment"
                        style="--mdc-theme-primary:red;--mdc-theme-on-primary:#FFFFFF;--mdc-button-horizontal-padding:20px;"
                        @click="${this.cancelFulfillment}"
                      >
                      </mwc-button>
                      <mwc-button
                        raised
                        label="Close"
                        style="--mdc-theme-primary:#2C7FAD;--mdc-button-horizontal-padding:50px;"
                        @click="${this.cancelClose}"
                      >
                      </mwc-button>
                    </div>
                  </dialog>`
                        : null}
            `}`;
            }
            case 'NOT_FOUND':
                if (this.adviseeSummary.status === 'FOUND') {
                    return html `
            <div class="errorContainer">
              <h1>${(_0 = this.adviseeSummary.adviseeSummary) === null || _0 === void 0 ? void 0 : _0.name} | Case # ${this.caseId}</h1>
              <p class="errorContainer__userInfo">
                Email: ${(_2 = (_1 = this.adviseeSummary.adviseeSummary) === null || _1 === void 0 ? void 0 : _1.corporateEmail) !== null && _2 !== void 0 ? _2 : (_4 = (_3 = this.adviseeSummary) === null || _3 === void 0 ? void 0 : _3.adviseeSummary) === null || _4 === void 0 ? void 0 : _4.personalEmail}
                  | Hub: ${(_5 = this.adviseeSummary.adviseeSummary) === null || _5 === void 0 ? void 0 : _5.slug} 
                  ${this.userLevelBenefit.status === 'FOUND'
                        && ((_6 = this.userLevelBenefit.userLevelBenefit) === null || _6 === void 0 ? void 0 : _6.wikiLink)
                        && ((_7 = this.userLevelBenefit.userLevelBenefit) === null || _7 === void 0 ? void 0 : _7.benefitGroupFriendly)
                        ? html ` | Benefit Group: <strong>
                        <a href="${(_8 = this.userLevelBenefit.userLevelBenefit) === null || _8 === void 0 ? void 0 : _8.wikiLink}" target="_blank">${(_9 = this.userLevelBenefit.userLevelBenefit) === null || _9 === void 0 ? void 0 : _9.benefitGroupFriendly}</a></strong>`
                        : null}
              </p>
              <p>An Aimee User has been located for this case, their profile is available below.</p>
              <p>Fulfillment unavailable, a fulfillment is created after completing a case.  If the case is complete and is not here, please try saving the Contact record, then save the Case record and refresh this page.  If it still does not appear or you suspect another issue please email <a href="mailto:helpdesk@financialfinesse.com?subject=Missing fulfillment for case ${this.caseId} &body=Error:${this.fulfillment.errorMessage}">helpdesk@financialfinesse.com</a>.</p>
              <div class="fulfillmentError">${unsafeHTML(this.fulfillment.errorMessage)}</div>
              ${this.renderCopyButton(this.fulfillment.status)}
            </div>

            ${this.renderTabs()}
         `;
                }
                if (this.userLevelBenefit.status === 'FOUND'
                    && ((_10 = this.userLevelBenefit.userLevelBenefit) === null || _10 === void 0 ? void 0 : _10.wikiLink)
                    && ((_11 = this.userLevelBenefit.userLevelBenefit) === null || _11 === void 0 ? void 0 : _11.benefitGroupFriendly)
                    && (this.adviseeSummary.status === 'NOT_FOUND' || !this.userId)) {
                    return html `
            <div class="errorContainer">
             <h1>Fulfillment Not Found | Case # ${this.caseId}</h1>
              <p class="errorContainer__userInfo">
                Email: ${this.email}
                ${this.userLevelBenefit.status === 'FOUND'
                        && ((_12 = this.userLevelBenefit.userLevelBenefit) === null || _12 === void 0 ? void 0 : _12.wikiLink)
                        && ((_13 = this.userLevelBenefit.userLevelBenefit) === null || _13 === void 0 ? void 0 : _13.benefitGroupFriendly)
                        ? html ` | Benefit Group: <strong>
                      <a href="${(_14 = this.userLevelBenefit.userLevelBenefit) === null || _14 === void 0 ? void 0 : _14.wikiLink}" target="_blank">${(_15 = this.userLevelBenefit.userLevelBenefit) === null || _15 === void 0 ? void 0 : _15.benefitGroupFriendly}</a></strong>`
                        : null}
              </p>
              <p>No Aimee contact has been located for this case but a User Level Benefit has been found.
              <p>A fulfillment is made available after completing a case.  If the case is complete and is not here, please try saving the Contact record, then save the Case record and refresh this page.  If it still does not appear or you suspect another issue please email <a href="mailto:helpdesk@financialfinesse.com?subject=Missing fulfillment for case ${this.caseId} &body=Error:${this.fulfillment.errorMessage}">helpdesk@financialfinesse.com</a>.</p>
              <div class="fulfillmentError">${unsafeHTML(this.fulfillment.errorMessage)}</div>
              ${this.renderCopyButton(this.fulfillment.status)}
            </div>

            ${this.renderUserError()}
          `;
                }
                if (this.adviseeSummary.status === 'NOT_FOUND' || !this.userId) {
                    return html `
            <div class="errorContainer">
             <h1>Fulfillment Not Found | Case # ${this.caseId}</h1>
              <p>No Aimee contact has been located for this case. If you suspect this to be in error, verify the contact's email address, save the contact and refresh this page.
              <p>A fulfillment is made available after completing a case.  If the case is complete and is not here, please try saving the Contact record, then save the Case record and refresh this page.  If it still does not appear or you suspect another issue please email <a href="mailto:helpdesk@financialfinesse.com?subject=Missing fulfillment for case ${this.caseId} &body=Error:${this.fulfillment.errorMessage}">helpdesk@financialfinesse.com</a>.</p>
              <div class="fulfillmentError">${unsafeHTML(this.fulfillment.errorMessage)}</div>
              ${this.renderCopyButton(this.fulfillment.status)}
            </div>

            ${this.renderUserError()}
          `;
                }
            case 'INITIALIZING':
            case 'LOADING':
                return html `<loading-spinner loadingText="Loading fulfillment..."></loading-spinner>`;
            case 'ERRORED':
            default:
                return html `
          <div class="errorContainer">
            <h1>Fulfillment Not Found | Case # ${this.caseId}</h1>
            <p>A fulfillment is made available after completing a case.  If the case is complete and is not here, please try saving the Contact record, then save the Case record and refresh this page.  If it still does not appear or you suspect another issue please email <a href="mailto:helpdesk@financialfinesse.com?subject=Missing fulfillment for case ${this.caseId} &body=Error:${this.fulfillment.errorMessage}">helpdesk@financialfinesse.com</a>.</p>
            <div class="fulfillmentError">${unsafeHTML(this.fulfillment.errorMessage)}</div>
            ${this.renderCopyButton(this.fulfillment.status)}
         </div>
        `;
        }
    }
};
FulfillmentSummaryElement.styles = css `
    :host {
      min-width: 100%;
      min-height: 100%;
    }

    .fulfillmentHeader {
      font-size: 24px;
      font-weight: 700;
      color: #073853;
      margin: 0 0 17px;
      padding: 0;
      display: block;
      text-decoration: none;
    }
    .fulfillmentHeaderIcon {
      width: 24px;
      height: 24px;
      vertical-align: middle;
      margin-top: -4px;
    }
    .fulfillmentHeaderMeta {
      margin: 10px 10px 20px;
      font-size: 14px;
      font-weight: 400;
    }
    .fulfillmentHeaderMeta a {
      color: #007cab;
      text-decoration: none;
    }
    .fulfillment {
      display: flex;
    }
    .fulfillmentContainer {
      flex: 1;
      margin-right: 25px;
    }
    .fulfillmentEmail {
      border-radius: 15px;
      background: #fff;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
      grid-column-start: 1;
    }
    .fulfillmentInfo {
      margin-top: 70px;
    }
    .fulfillmentEmail__header {
      padding: 15px 30px 13px;
    }
    .fulfillmentEmail__headerMeta {
      display: flex;
      margin-bottom: 9px;
    }
    .fulfillmentEmail__headerName {
      font-size: 18px;
      font-weight: 700;
      flex: 1;
    }
    .fulfillmentEmail__headerDate {
      font-size: 10px;
      font-weight: 400;
      color: #a5a5a5;
    }
    .fulfillmentEmail__headerCc,
    .fulfillmentEmail__headerTo,
    .fulfillmentEmail__headerSubject {
      display: flex;
      align-items: center;
    }
    .fulfillmentEmail__headerCcLabel,
    .fulfillmentEmail__headerToLabel,
    .fulfillmentEmail__headerSubjectLabel {
      font-size: 12px;
      font-weight: 500;
      letter-spacing: 0.05em;
      color: #383838;
      flex: 0 0 60px;
    }
    .fulfillmentEmail__headerCc,
    .fulfillmentEmail__headerTo {
      margin-bottom: 6px;
    }
    .fulfillmentEmail__headerCcInput,
    .fulfillmentEmail__headerToInput,
    .fulfillmentEmail__headerSubjectInput {
      flex: 1;
      font-family: inherit;
      font-size: 12px;
      font-weight: 400;
      border-radius: 4px;
      border: 1px solid #efefef;
      background: #fff;
      margin: 0;
      padding: 3px 12px;
    }
    .fulfillmentEmail__headerCcInput,
    .fulfillmentEmail__headerToInput {
      background: #f7f7fa;
    }
    .fulfillmentInfo {
      grid-column-start: 1;
      border-radius: 15px;
      background: #fff;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
    }
    .page__body h3 {
      margin: 0 0 10px;
      padding: 0;
      font-size: 22px;
      color: #073853;
      font-family: var(--font-family);
      text-transform: uppercase;
      font-weight: normal;
    }
    .fulfillmentInfo__navItem {
      text-transform: none;
      letter-spacing: normal;
    }
    .fulfillmentInfo__navItem[selected] {
      color: #007cab;
      box-shadow: inset 0 -2px 0 0 #007cab;
      font-weight: 700;
    }
    .errorContainer {
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.16);
      padding: 40px;
      margin-bottom: 30px;
    }
    .errorContainer h1 {
      margin: 0 0 30px 0;
      padding: 0;
      color: #00507c;
      font-size: 24px;
    }
    .errorContainer h2 {
      margin: 0 0 30px 0;
      padding: 0;
      color: #007CAB;
      font-size: 20px;
    }
    .errorContainer p {
      color: #323232;
      font-size: 16px;
      line-height: 1.4;
    }
    .errorContainer .userInfo {
      font-size: 20px;
      margin: 0 0 30px;
    }
    .errorContainer a {
      text-decoration: none;
      color: #007cab;
    }
    .fulfillmentError {
      margin: 20px 0;
      font-size: 10px;
      font-weight: normal;
      line-height: 1.3;
    }
    .copyError,
    .refresh {
      border: 0;
      border-radius: 6px;
      margin: 0;
      padding: 8px 12px;
      color: #fff;
      background: #00507c;
      font-weight: 500;
      font-family: inherit;
      cursor: pointer;
      margin-top: 10px;
    }
    .sendMessage {
      margin: 20px 0;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.3;
      border: 1px solid #f2f2f2;
      background: #fff;
      padding: 10px;
      border-radius: 6px;
    }
    #cancel__dialog {
      border-radius: 15px;
      box-shadow: 0 3px 6px #00000029;
      width: 600px;
      border: none;
      padding: 0;
    }
    .cancel__header {
      align-items: baseline;
      border-bottom: 1px solid #efefef;
      color: #383838;
      display: flex;
      flex: 0 1 auto;
      justify-content: center;
      padding: 19px 22px;
    }
    .cancel__header h1 {
      font-size: 20px;
      font-weight: 600;
      margin: 0;
    }
    .cancel__content {
      max-height: 300px;
      padding: 0 45px;
      overflow: hidden;
    }
    .cancel__bottomControls {
      align-items: flex-start;
      border-top: 1px solid #efefef;
      box-sizing: border-box;
      display: flex;
      flex: 0 1 125px;
      justify-content: space-between;
      padding: 14px 40px;
    }
    #fulfillmentCancellation__reason {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      height: 250px;
      resize: none;
    }
    #cancel__status {
      padding: 0 45px;
    }
    #fulfillmentEmail__bottomButtons {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  `;
__decorate([
    query('#subject__input')
], FulfillmentSummaryElement.prototype, "_subject", void 0);
__decorate([
    query('#recipientEmail__input')
], FulfillmentSummaryElement.prototype, "_recipientEmail", void 0);
__decorate([
    query('#ccEmail__input')
], FulfillmentSummaryElement.prototype, "_ccEmail", void 0);
__decorate([
    query('#fulfillmentCancellation__reason')
], FulfillmentSummaryElement.prototype, "_cancelReason", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "adviseeSummary", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "saveTimer", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "buttonDisabled", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "sendFulfillmentMessage", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "coachEmail", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "location", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "email", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "cancelStatus", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "hubSlug", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "userId", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "hubId", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "employeeId", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "caseId", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "tinymceConfig", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "fulfillment", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "latestEmail", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "lastSentEmail", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "lastReceivedEmail", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "customActionItem", void 0);
__decorate([
    query('#cancel__dialog')
], FulfillmentSummaryElement.prototype, "_dialog", void 0);
__decorate([
    subscribe(),
    state()
], FulfillmentSummaryElement.prototype, "blueUser", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "parsedToken", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "content", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "tinymceEditor", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "pages", void 0);
__decorate([
    property()
], FulfillmentSummaryElement.prototype, "historyTab", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "userLevelBenefit", void 0);
__decorate([
    state()
], FulfillmentSummaryElement.prototype, "errorIsCopied", void 0);
FulfillmentSummaryElement = __decorate([
    customElement('fulfillment-summary')
], FulfillmentSummaryElement);
export { FulfillmentSummaryElement };
//# sourceMappingURL=summary.js.map